import type { ApiAcceptedLanguage } from '@izimi/api';

class NabanQueryKeys {
  constructor(private prefix: string) {}

  getNabanAuthenticationModes() {
    return [this.prefix, 'authenticationModes'];
  }

  getNabanDeeds(authenticationModeToken: string, language: ApiAcceptedLanguage) {
    return [this.prefix, 'deeds', authenticationModeToken, language];
  }

  getNabanDeed(authenticationModeToken: string, napId: string, language: ApiAcceptedLanguage) {
    return [this.prefix, 'deed', authenticationModeToken, napId, language];
  }
}

export default NabanQueryKeys;
